export const GET_CONTACT_PERSON = `GET_CONTACT_PERSON`;
export const GET_BANKDATA = `GET_BANKDATA`
export const GET_MEMBERGROUP = `GET_MEMBERGROUP`
export const GET_MEMBERS = `GET_MEMBERS`
// Participants
export const GET_PARTICIPANT = `GET_PARTICIPANT`
// Participants
export const GET_EVENT = `GET_EVENT`

// member type correction
export const SELECTED_MEMBER_TYPE_CORRECTION_MEMBER_IDS = `selectedMemberIds`
export const EXCLUDED_MEMBER_TYPE_CORRECTION_MEMBER_IDS = `excludedMemberIds`
export const HAS_MEMBER_TYPE_CORRECTION_CANDIDATES = `hasCandidates`
export const HAS_MEMBER_TYPE_CORRECTION_WARNINGS = `hasWarnings`
export const CURRENT_MEMBER_TYPE_CORRECTION_STEP = `currentStep`
export const IS_MEMBER_TYPE_CORRECTION_COMPLETED = `isCompleted`
